import type {Middleware, MiddlewareAPI} from '@reduxjs/toolkit'
import {isRejectedWithValue} from '@reduxjs/toolkit'
import {enqueueSnackbar} from 'notistack'
import {logout} from 'store/authSlice'

const EXPIRED_STATUS_CODE = [400, 401]

const invalidRetriesMessage = {
  message: 'DefineAuthChallenge failed with error Invalid OTP.',
  replaceMessage: 'Sorry, you have exceeded the maximum number of attempts.'
}

export const errorHandler: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      console.log('Errors handle: ' + action.payload.data.error.message)

      if (action.payload.data.error.message === invalidRetriesMessage.message) {
        enqueueSnackbar(invalidRetriesMessage.replaceMessage, {
          variant: 'error', autoHideDuration: 1000
        })
        return next(action)
      }

      const invalidPasswordLogin =
        action.meta.arg.endpointName === 'login' &&
        action.payload.data.error.message === 'Validation error'
      if (invalidPasswordLogin) {
        enqueueSnackbar('Invalid password.', {
          variant: 'error', autoHideDuration: 1000
        })
        return next(action)
      }

      if (EXPIRED_STATUS_CODE.includes(action.payload.status)) {
        enqueueSnackbar(action.payload.data.error.message, { variant: 'error' , autoHideDuration: 1000})
        api.dispatch(logout())

        return next(action)
      }

      if (action.payload.data.error.message === 'Validation error') {
        enqueueSnackbar(action.payload.data.error.errors[0].message, {
          variant: 'error', autoHideDuration: 1000
        })
        return next(action)
      }

      enqueueSnackbar(
        action.payload.data.message ||
          action.payload.data.msg ||
          action.payload.data.error.message,
        {
          variant: 'error', autoHideDuration: 1000
        }
      )

      return next(action)
    }

    return next(action)
  }
